import { Engine } from '@babylonjs/core/Engines/engine';
import { HDRCubeTexture } from '@babylonjs/core/Materials/Textures/hdrCubeTexture';
import { EnvironmentTextureTools } from '@babylonjs/core/Misc/environmentTextureTools';
import { Observable } from 'rxjs';

export function convertHdrToEnv(hdrFile: Blob, hdrSize: number): Observable<Blob> {
    return new Observable(subject => {
        const dataUri = URL.createObjectURL(hdrFile);
        const canvas = document.createElement('canvas');
        const dummyEngine = new Engine(canvas, true, {
            premultipliedAlpha: false,
        });

        const env = new HDRCubeTexture(dataUri, dummyEngine, hdrSize, false, true, false, true, () => {
            EnvironmentTextureTools.CreateEnvTextureAsync(env).then(buffer => {
                URL.revokeObjectURL(dataUri);
                dummyEngine.dispose();
                subject.next(new Blob([buffer]));
                subject.complete();
            });
        });
    });

    // return new Promise((resolve, reject) => {
    //     const env = new HDRCubeTexture(
    //         "textures/environment.hdr",
    //         scene,
    //         hdrSize,
    //         false,
    //         true,
    //         false,
    //         true,
    //         () => {
    //             console.log("environment loaded");

    //             EnvironmentTextureTools
    //                 .CreateEnvTextureAsync(env)
    //                 .then((buffer) => {
    //                     console.log(buffer);
    //                     console.log('success');
    //                     resolve(new Blob([buffer]));
    //                 })
    //         }
    //     );
    // });
}
